import { render, staticRenderFns } from "./LogNote.vue?vue&type=template&id=5b65feeb&scoped=true"
import script from "./LogNote.vue?vue&type=script&lang=js"
export * from "./LogNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65feeb",
  null
  
)

export default component.exports